<div class="modal-header">
    <span class="modal-title">Export Clock Entries</span>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form class="form-inline">
        <fieldset>
            <legend>Range</legend>
            <div class="form-group">
                <div class="input-group">
                    <span>From : </span>
                    <input class="form-control" placeholder="yyyy-mm-dd" name="dpf" [(ngModel)]="datefrom" ngbDatepicker
                        #dpf="ngbDatepicker" readonly>
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dpf.toggle()" type="button"></button>
                    </div>
                    <span>To : </span>
                    <input class="form-control" placeholder="yyyy-mm-dd" name="dpt" [(ngModel)]="dateto" ngbDatepicker
                        #dpt="ngbDatepicker" readonly>
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dpt.toggle()" type="button"></button>
                    </div>
                </div>
            </div>
        </fieldset>
        <button class="btn btn-primary timeinrow" (click)="exportData()">Export</button>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">Close</button>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>